import {useMemo} from "react";
import styles from "components/sections/search/AllSearchResult.module.scss";
import {checkHasConsonant, getLocalStorageCountryCode, numberWithComma} from "common/utils";
import HorizontalProducts from "components/layout/store/products/HorizontalProducts";
import {SectionTitle} from "components/sections/search/SectionTitle";
import {useRouter} from "next/router";
import {NoStoreSearchResult} from "components/sections/search/NoSearchResult";
import useTranslation from 'next-translate/useTranslation';
import Trans from 'next-translate/Trans';


const KEY_STORE_TAB = 'store';

export const OverallStoreSectionRow = (props) => {
    const {filterInfoList, storeResult} = props;

    const router = useRouter();

    const section = router.query.tab;
    const loggingPrefix = section === 'store' ? 'StoreSearch' : 'AllSearch';
    const countryCode = getLocalStorageCountryCode() ?? 'KR';
    const {t} = useTranslation('search-OverallStoreSection');

    const handleShowMoreClick = () => {
        const filterInfo = filterInfoList[0];
        const query = router.query.q;
        typeof mixpanel !== 'undefined' && mixpanel.track(
            `${loggingPrefix}OverallStoreSectionShowMoreClick`,
            {
                filter_type: filterInfo.filter_type,
                filter_name: filterInfo.name,
                query,
            }
        );
        let additionalTab = {phase: '2'};
        if (filterInfo.filter_type === 'brand') {
            additionalTab['brands'] = filterInfo.id;
            additionalTab['q'] = query;
            additionalTab['order'] = 'sell_count';
        } else if (filterInfo.filter_type === 'tag') {
            additionalTab['categories'] = filterInfo.id;
            additionalTab['q'] = query;
            additionalTab['order'] = 'sell_count';
        } else if (filterInfo.filter_type === 'name') {
            additionalTab['name_only'] = 'true';
            additionalTab['q'] = query;
            additionalTab['order'] = 'sell_count';
        }
        router.push(
            {query: Object.assign({}, {tab: KEY_STORE_TAB}, additionalTab)},
            undefined,
            {
                shallow: true,
                scroll: false,
            }
        );
    };

    const onProductClick = (product, itemIdx) => {
        typeof mixpanel !== 'undefined' && mixpanel.track(
            `${loggingPrefix}StoreSectionItemClick`,
            {
                productName: product.name,
                productId: product.id,
                itemIdx: itemIdx,
            }
        );
        if (props.onItemClick) {
            props.onItemClick();
        }
    };

    const title = useMemo(() => {
        const filterInfo = filterInfoList[0];
        if (filterInfo.filter_type === 'brand') {
            return (
                <Trans
                    i18nKey="search-OverallStoreSection:OverallStoreSectionRow.popularProducts"
                    components={[<span className={styles.searchTitleKeyword} />, <span className={styles.count} />]}
                    values={{
                        name: filterInfo.name,
                        count: numberWithComma(storeResult.count),
                    }}
                />
            );
        }
        if (filterInfo.filter_type === 'tag') {
            return (
                <Trans
                    i18nKey="search-OverallStoreSection:OverallStoreSectionRow.collectedProducts"
                    components={[<span className={styles.searchTitleKeyword} />, <span className={styles.count} />]}
                    values={{
                        name: filterInfo.name,
                        count: numberWithComma(storeResult.count),
                    }}
                />
            );
        }
        if (filterInfo.filter_type === 'name') {
            const particle = (
                countryCode === 'KR'
            ) ? (checkHasConsonant(filterInfo.name) ? '이' : '가') : '';

            return (
                <Trans
                    i18nKey="search-OverallStoreSection:OverallStoreSectionRow.productsWithName"
                    components={[<span className={styles.searchTitleKeyword} />, <span className={styles.count} />]}
                    values={{
                        name: filterInfo.name.replace('/', '').replace('\\', ''),
                        particle: particle,
                        count: numberWithComma(storeResult.count),
                    }}
                />
            );
        }
        return t('OverallStoreSectionRow.store');
    }, [filterInfoList, t]);

    const filterInfo = filterInfoList[0];

    return (
        <div className={styles.sectionContainer}>
            <SectionTitle title={title} onClick={handleShowMoreClick}/>
            <div className={styles.storeListContainer}>
                <HorizontalProducts
                    products={storeResult.products}
                    onProductClick={onProductClick}
                    width={135} imageRatio={'100%'}
                    productNameMaxLine={2}
                    miniScrapIcon
                    onShowMoreClick={storeResult.products.length >= 10 ? handleShowMoreClick : null}
                    highlightKeyword={filterInfo.filter_type === 'name' ? filterInfo.name : null}
                    useBestCouponDiscount={true}
                />
            </div>
        </div>
    )
};


export const OverallStoreSection = (props) => {
    const {overallStoreResult, onItemClick, query} = props;

    const hasBrandResult = overallStoreResult && overallStoreResult.filtered_product_list.some(x => x.filter_info_list[0].filter_type === 'brand');
    const filteredProductList = hasBrandResult ?
        overallStoreResult.filtered_product_list.filter(x => x.filter_info_list[0].filter_type !== 'name') :
        overallStoreResult.filtered_product_list;
    filteredProductList.sort((a, b) => {
        if (a.filter_info_list[0].filter_type === 'brand') {
            return -1;
        }
        if (b.filter_info_list[0].filter_type === 'brand') {
            return 1;
        }
        if (a.filter_info_list[0].filter_type === 'name') {
            return -1;
        }
        if (b.filter_info_list[0].filter_type === 'name') {
            return 1;
        }
        return 0;
    });

    console.log('filteredProductList', filteredProductList);

    return (
        <>
            {
                overallStoreResult && overallStoreResult.filtered_product_list.length > 0 ?
                    filteredProductList.map((e, index) => {
                        return (
                            <OverallStoreSectionRow
                                filterInfoList={e.filter_info_list}
                                storeResult={e.search_result}
                                onItemClick={onItemClick}
                                key={`${e.filter_info_list[0].filter_type}-${e.filter_info_list[0].name}`}
                            />
                        )
                    }) :
                    <NoStoreSearchResult query={query}/>
            }
        </>
    )
};
